module.exports = __webpack_public_path__ + "img/right-arrow.920552a2.svg";